import React, { useState } from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import Icon from '../icon';
import Button from '../button';
import Panel from '../panel';
const StyledButtonTextContainer = styled.View`
  margin-left: auto;
`;
const FlexContainer = styled.View`
  display: flex;
  flex-direction: row;
`;
const StyledRequirementContainer = styled(FlexContainer)`
  padding: 4px 8px;
`;
const StyledRow = styled(FlexContainer)`
  align-items: center;
  width: 100%;
`;
const styles = {
  icon: {
    padding: 6,
    backgroundColor: Colors.lightGray200,
    borderRadius: 4
  },
  panel: {
    backgroundColor: Colors.lightGray100,
    padding: 16
  }
};
export default function KycRequirements(props) {
  const [showReq, setShowReq] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledRow, null, /*#__PURE__*/React.createElement(Icon.AdvanceLineIcon, {
    name: props.icon,
    size: 20,
    color: Colors.advanceBlue400,
    style: styles.icon
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: "medium"
  }, props.label), /*#__PURE__*/React.createElement(StyledButtonTextContainer, null, /*#__PURE__*/React.createElement(Button.Text, {
    size: "small",
    onPress: () => setShowReq(!showReq)
  }, showReq ? 'Hide Details' : 'View Details'))), showReq && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Panel, {
    alignItems: "flex-start",
    style: styles.panel
  }, props.submitOne && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, null, "Submit one (1) of the following:"), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  })), props.list.map((requirement, i) => /*#__PURE__*/React.createElement(StyledRequirementContainer, {
    key: i
  }, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    type: "paragraph",
    color: Colors.gray500
  }, "\u2022"), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    width: true
  }), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    type: "paragraph",
    color: Colors.gray500
  }, requirement))))));
}
KycRequirements.defaultProps = {
  label: '',
  icon: 'ID',
  list: [],
  submitOne: false
};
KycRequirements.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  list: PropTypes.array,
  submitOne: PropTypes.bool
};
//# sourceMappingURL=kyc-requirements.js.map